var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitleAdm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.79 92.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.63;}.cls-2{fill:#fff;stroke:#e6e6e6;stroke-miterlimit:10;stroke-width:2px;}.cls-3{opacity:0.97;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_05",
    "data-name": "icon 05",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "118.79 65.41 57.06 65.41 57.06 18.37 72.5 18.37 77.41 23.73 118.79 23.73 118.79 65.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "103.61 74.21 41.89 74.21 41.89 27.17 57.33 27.17 62.23 32.52 103.61 32.52 103.61 74.21"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_04",
    "data-name": "icon 04",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.8,32.84H43.34l-3-7.33,6-6.07a2.9,2.9,0,0,0,0-4.05l-6-6.08a2.81,2.81,0,0,0-4,0l-6,6.08-7.21-3V3.76A2.85,2.85,0,0,0,20.34.9H11.88A2.85,2.85,0,0,0,9.05,3.76v8.6l-7.16,3c0,11.23-.2,22.47-.21,33.71a5,5,0,0,1-.58,2.4c0,4.62.07,9.24,0,13.86l.72-.73,7.21,3v8.59a2.86,2.86,0,0,0,2.83,2.87h8.46a2.85,2.85,0,0,0,2.82-2.87V67.64l7.21-3,6,6.07a2.79,2.79,0,0,0,4,0l6-6.07a2.9,2.9,0,0,0,0-4l-6-6.08,3-7.32H51.8a2.85,2.85,0,0,0,2.82-2.87V35.7A2.85,2.85,0,0,0,51.8,32.84Z",
    transform: "translate(0.04 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.43,44.84H33l-3-7.32,6-6.08a2.9,2.9,0,0,0,0-4.05l-6-6.07a2.79,2.79,0,0,0-4,0l-6,6.07-7.21-3V15.77A2.85,2.85,0,0,0,10,12.9H1.91C1.86,25,1.69,37,1.68,49.08a5,5,0,0,1-.56,2.37c.07,7.5,0,15-.16,22.51.09,5.72.54,11.43.94,17.14H10a2.85,2.85,0,0,0,2.82-2.86v-8.6l7.21-3,6,6.08a2.81,2.81,0,0,0,4,0l6-6.08a2.9,2.9,0,0,0,0-4l-6-6.07,3-7.33h8.47a2.85,2.85,0,0,0,2.82-2.86V47.71A2.85,2.85,0,0,0,41.43,44.84Z",
    transform: "translate(0.04 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.42,35.29a15.31,15.31,0,0,0-9.66-.53c0,4.77-.08,9.55-.08,14.32a4.9,4.9,0,0,1-.57,2.38q.07,7,0,14A15.65,15.65,0,0,0,20.4,56,16,16,0,0,0,11.42,35.29Z",
    transform: "translate(0.04 0.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.73,46a4.17,4.17,0,0,0-4.06,3.33,5.41,5.41,0,0,1-.09.84s0,0,0,0A4.2,4.2,0,0,0,5.73,54.4a4.22,4.22,0,0,0,0-8.44Z",
    transform: "translate(0.04 0.1)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleAdm);
export default __webpack_public_path__ + "static/media/TitleAdm.f648ffcbfe52050f1f85e60ee828c932.svg";
export { ForwardRef as ReactComponent };